import React, { useState, useEffect, useContext, useLayoutEffect, useRef } from 'react';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import LoadingOverlay from 'react-loading-overlay';
import AlertAlgo from '../controls/AlertSnack'
import BeatLoader from 'react-spinners/BeatLoader';
import { Company } from '@users';
import ChatDetail from './ChatDetail'
import { ChatContext } from '@/ChatProvider';
import styles from '@styles/chat.module.css';

const spanEmptyTextValue = {
    marginTop: 11,
    marginLeft: 55,
    display: 'table',
    fontWeight: 'bold'
};

const statusStyle = (onLine) => ({
    position: 'absolute',
    bottom: 3,
    width: 14,
    height: 14,
    borderRadius: '50%',
    backgroundColor: onLine ? '#44b700' : '#B0B3B8',
    border: '2px solid white',
    left: 32
});

const avatarStyle = {
    position: 'relative',
    display: 'table',
    width: '100%',
    height: '50px',
    objectFit: 'cover'
};

const SeparatorDiv = ({ children }) => (
    <div>
        {children}
        <div style={{
            position: 'absolute',
            bottom: 0,
            right: 10,
            width: '100%',
            height: '1px',
            backgroundColor: '#ccc'
        }}></div>
    </div>
);

const ProfileBadge = ({ data }) => {
    return (
        <div style={avatarStyle} title={data.fullName}>
            <span className={styles.profileBadge}>{data.initial}</span><span style={spanEmptyTextValue}>{data.fullName}</span><span style={statusStyle(data.onLine)} ></span>
        </div>
    );
}

export function ContactList(props) {
    const [data, setData] = useState(null);
    const [dataRow, setDataRow] = useState(null);
    const [filter, setFilter] = useState('');
    const [open, setOpen] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const { chatUsers, state } = useContext(ChatContext);
    const alertRef = useRef(null);

    useLayoutEffect(() => {
        resizeForm();
    }, []);

    useEffect(() => {
        setTimeout(() => {//Wait until load page complete
            LoadData(chatUsers);
            setIsActive(false);
        }, 0);
    }, []);

    useEffect(() => {
        LoadData(data);
    }, [state.usersStatus]);

    const resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const elemHeader = document.querySelector('[data-id=headerContactList]');
            const header = elemHeader != null ? document.querySelector('[data-id=headerContactList]').offsetHeight : 0;
            const offSet = 80;
            const customHeight = height - header - offSet;
            const element = document.querySelector('#divContactList');

            if (element != null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 0);
    }

    const LoadData = (list) => {
        if (list) {
            const usersList = list.map(user => {
                if (state.usersStatus.includes(user.userCode + user.konekUserAssociationId + Company())) {
                    user.onLine = true;
                } else {
                    user.onLine = false;
                }
                return user;
            });
            setData(usersList);
        }
    }

    const handleClick = (obj) => {
        setDataRow(obj);
        setOpen(true);        
    }

    const handleClose = () => {
        setOpen(false);
        props.onClose();
    };

    const handleFilterChange = (event) => {
        setFilter(event.target.value);
    };

    const filteredList = data?.filter(row =>
        row.fullName.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <div id="divContactList" className={styles.konekCard} style={{ top: 135 }}>
            <LoadingOverlay
                active={isActive}
                spinner={<BeatLoader />}
                text={i18next.t('common:loading')}
            >
                <input
                    type="text"
                    value={filter}
                    onChange={handleFilterChange}
                    placeholder={i18next.t('chat:list.placeholderFilterMessage')}
                    className={styles.filter}
                />
                <List style={{
                    maxHeight: '100%',
                    overflowY: 'auto',
                    padding: 'fixed',
                    position: 'relative',
                    width: '100%'
                }}>
                    {filteredList?.map((obj, index) =>
                        <React.Fragment key={`${index}`}>
                            <div style={{ marginTop: "5px" }}>
                                <ListItem key={`${index}`} button onClick={() => handleClick(obj)}>
                                    <ListItemText disableTypography={true} primary={
                                        <React.Fragment>
                                            <SeparatorDiv>
                                                <ProfileBadge data={obj} />
                                            </SeparatorDiv>
                                        </React.Fragment>
                                    } />
                                </ListItem>
                            </div>
                        </React.Fragment>
                    )}
                </List>

                {dataRow != null && <ChatDetail data={dataRow} open={open} onClose={handleClose} />}
            </LoadingOverlay>
            <AlertAlgo ref={alertRef} />
        </div>
    );
}

export default withNamespaces(['menu', 'chat', 'common', 'error'], { wait: true })(ContactList);